module.exports = __webpack_public_path__ + "img/icon91.2ad92b15.png";